import { render, staticRenderFns } from "./DataEditorFeedback.vue?vue&type=template&id=1a681a2a&scoped=true&"
import script from "./DataEditorFeedback.vue?vue&type=script&lang=js&"
export * from "./DataEditorFeedback.vue?vue&type=script&lang=js&"
import style0 from "./DataEditorFeedback.vue?vue&type=style&index=0&id=1a681a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a681a2a",
  null
  
)

export default component.exports